<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <span class="el-breadcrumb__item" v-if="data.name.length>0"><span class="el-breadcrumb__inner">{{data.name}}</span>
        <span role="presentation" class="el-breadcrumb__separator">:</span>
      </span>
      <el-breadcrumb-item v-for="(item, index ) in routeList" :key="index" :to="{ path: item.url }">{{ item.name}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ data.currentName}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<style lang="scss" scoped>
/deep/ .el-breadcrumb__inner.is-link {
  font-weight: 500;
}

/deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: 800;
}
</style>

<script>
let _ = require("lodash");
export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        navList: [],
        name: "",
        currentName: "",
      }),
    },
  },
  data() {
    return {
      routeList: [],
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      this.routeList = [];
      let self = this;
      _.forEach(this.data.navList, function (item) {
        self.routeList.push({
          url: self.buildLink(item.link, item.data),
          name: item.name,
        });
      });
    },
    buildLink(url, data) {
      if (data) {
        let dataStr = "";
        Object.keys(data).forEach((key) => {
          dataStr += key + "=" + data[key] + "&";
        });
        if (dataStr !== "") {
          dataStr = dataStr.substr(0, dataStr.lastIndexOf("&"));
          url = url + "?" + dataStr;
        }
      }
      return url;
    },
  },
  watch: {
    data: {
      deep: true,
      handler: function () {
        this.init();
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/breadcrumbNavigationBar.vue